import useMutationApi from '../../useMutationApi';
import { SupportedGPTModels } from 'src/pages/authenticated/core/spreadsheets/types/spreadsheetTypes';

interface WorkflowPreprocessRequest {
  data: string;
  instructions: string;
  fileNames: string[];
  sheetName: string;
  model?: SupportedGPTModels;
  testMode?: boolean;
}

interface WorkflowPreprocessResponse {
  success: boolean; // Whether all workflow steps executed successfully
  data: {
    cleanedCsv: string;
    workflowSteps?: Array<{
      id?: string;
      type: string;
      description: string;
      inputs?: unknown;
      outputs?: {
        columns?: string[];
        [key: string]: unknown;
      };
    }>;
    rawWorkflowSteps?: Array<{
      id?: string;
      type: string;
      description: string;
      inputs?: unknown;
      outputs?: {
        columns?: string[];
        [key: string]: unknown;
      };
    }>;
    explanation: string[];
    analysis: {
      rowCount: number;
      columnCount: number;
      detectedHeaders: string[];
    };
  };
  error?: string; // Error message if success: false
  failedStepId?: string; // ID of the step that failed (if any)
}

const useWorkflowPreprocess = () => {
  return useMutationApi<WorkflowPreprocessRequest, WorkflowPreprocessResponse>({
    endpoint: 'spreadsheet/workflow/preprocess',
    method: 'POST',
    successMessage: 'Data preprocessing completed successfully',
    showSuccessToast: false, // Let the UI handle success feedback
  });
};

export default useWorkflowPreprocess;
export type { WorkflowPreprocessRequest, WorkflowPreprocessResponse };
